export default __webpack_public_path__ + "static/finance-1-966de1652cafa5d8de95e1024b9ad049.png";